import { CopyParagraph } from '@sleepstation/components-copy'
import { VLayout } from '@sleepstation/components-layouts'
import { LAYOUT_SPACING } from '@sleepstation/const'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { formatAuthorNameWithHonorific } from '../../../../../../helpers/formatting/author'
import AvatarHeader from '../../../../../shared/AvatarHeader'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(VLayout).attrs({ spacing: LAYOUT_SPACING.MEDIUM })``

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const LeadAuthor = ({ author }) => {
  const { avatarImage, role, bio } = author
  const title = formatAuthorNameWithHonorific(author)

  return (
    <Layout>
      <AvatarHeader title={title} subtitle={role} image={avatarImage} />
      <CopyParagraph>{bio}</CopyParagraph>
    </Layout>
  )
}

LeadAuthor.propTypes = {
  author: PropTypes.object.isRequired,
}

export default LeadAuthor
